import api from "api/api";

export const createConsultantQuery = async ({ data, userScope }) =>
  await api.post(`/directory/consultant?scope=${userScope}`, data);

export const getConsultantByIdQuery = async ({ id, userScope }) =>
  await api.get(`/directory/consultant/${id}?scope=${userScope}`);

export const updateConsultantQuery = async ({ id, data, userScope }) =>
  await api.put(`/directory/consultant/${id}?scope=${userScope}`, data);

export const deleteConsultantQuery = async ({ id, userScope }) =>
  await api.delete(`/directory/consultant/${id}?scope=${userScope}`);

export const getConsultantBySlugQuery = async ({ slug, userScope }) =>
  await api.get(`/directory/consultant/slug/${slug}?scope=${userScope}`);

export const getConsultantSixYearsReviewQuery = async ({ id, userScope }) =>
  await api.get(
    `directory/consultant/document/six_year_review/${id}?scope=${userScope}`
  );
